module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "借用编号"
    },
    model: {
      value: (_vm.filters.loanId),
      callback: function($$v) {
        _vm.filters.loanId = $$v
      },
      expression: "filters.loanId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "借用设备"
    },
    model: {
      value: (_vm.filters.device),
      callback: function($$v) {
        _vm.filters.device = $$v
      },
      expression: "filters.device"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "借用人"
    },
    model: {
      value: (_vm.filters.loaner),
      callback: function($$v) {
        _vm.filters.loaner = $$v
      },
      expression: "filters.loaner"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "联系方式"
    },
    model: {
      value: (_vm.filters.phone),
      callback: function($$v) {
        _vm.filters.phone = $$v
      },
      expression: "filters.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择组别"
    },
    model: {
      value: (_vm.filters.group),
      callback: function($$v) {
        _vm.filters.group = $$v
      },
      expression: "filters.group"
    }
  }, _vm._l((_vm.groupOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.groupName,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "398px"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.filters.status = $$v
      },
      expression: "filters.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getPageLoans(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.formattedLoanList,
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-form', {
          staticClass: "loan-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "借用编号"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.loanId))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "借用设备"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.device))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "状态"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedStatus))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "借用人"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.loaner))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系方式"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.phone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "邮箱"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.email))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "借用时间"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedLoanTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "应归还时间"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedReturnTime))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "实际归还时间"
          }
        }, [_c('span', [_vm._v(_vm._s(scope.row.formattedRealReturnTime))])])], 1)]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loanId",
      "label": "借用编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device",
      "label": "借用设备"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loaner",
      "label": "借用人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedLoanTime",
      "label": "借用时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedReturnTime",
      "label": "应归还时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "formattedStatus",
      "label": "状态",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "350"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [(_vm.$store.state.user.userData.authority.indexOf(1) > -1 ||
          _vm.$store.state.user.userData.authority.indexOf(3) > -1) ? [(scope.row.status === 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleAdminExamine(scope.row, true)
            }
          }
        }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleAdminExamine(scope.row, false)
            }
          }
        }, [_vm._v("不通过")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.$store.state.user.userData.authority.indexOf(2) > -1) ? [(scope.row.status === 2) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.handleLeaderExamine(scope.row, true)
            }
          }
        }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (scope.row.status === 2) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.handleLeaderExamine(scope.row, false)
            }
          }
        }, [_vm._v("不通过")]) : _vm._e()] : _vm._e(), _vm._v(" "), (scope.row.status > 2) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.showCreditBox(scope.row)
            }
          }
        }, [_vm._v("添加信用记录")]) : _vm._e()]
      }]
    ])
  })], 1)], _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.getPageLoans
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加信用记录"
    },
    on: {
      "close": function($event) {
        _vm.resetForm('addCreditForm')
      }
    },
    model: {
      value: (_vm.addCreditVisible),
      callback: function($$v) {
        _vm.addCreditVisible = $$v
      },
      expression: "addCreditVisible"
    }
  }, [_c('el-form', {
    ref: "addCreditForm",
    attrs: {
      "model": _vm.addCreditForm,
      "label-width": "110px",
      "rules": _vm.addCreditFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加分/减分",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addCreditForm.type),
      callback: function($$v) {
        _vm.addCreditForm.type = $$v
      },
      expression: "addCreditForm.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("加分")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("减分")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分数",
      "prop": "score"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 20
    },
    model: {
      value: (_vm.addCreditForm.score),
      callback: function($$v) {
        _vm.addCreditForm.score = $$v
      },
      expression: "addCreditForm.score"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.addCreditForm.message),
      callback: function($$v) {
        _vm.addCreditForm.message = $$v
      },
      expression: "addCreditForm.message"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "借用记录编号",
      "prop": "loanId"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.addCreditForm.loanId),
      callback: function($$v) {
        _vm.addCreditForm.loanId = _vm._n($$v)
      },
      expression: "addCreditForm.loanId"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addCreditVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addCreditLoading
    },
    nativeOn: {
      "click": function($event) {
        _vm.addCreditSubmit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnAddCreditText) + "\n      ")])], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2717371b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/loan/loan.vue
// module id = 530
// module chunks = 1